import React from 'react';
import { avatar } from './styles.sass';

export default function Avatar({ size = 27, src, userId, className = '' }) {
  const srcAttrs = getSourceAttributes(src, userId);
  return (
    <img
      onDragStart={evt => {
        evt.preventDefault();
      }}
      alt="Avatar"
      className={`${avatar} ${className}`}
      width={size}
      height={size}
      {...srcAttrs}
    />
  );
}

function getSourceAttributes(src, userId) {
  if (src) {
    return {
      src,
    };
  }
  const randomAvatar = getRandomAvatarSources(userId);
  if (randomAvatar) {
    const { oneX, twoX } = randomAvatar;
    return {
      src: oneX,
      srcSet: `${oneX} 1x, ${twoX} 2x`,
    };
  }

  // in cases where station data is loading, user ID / sources won't be ready
  return {
    style: {
      visibility: 'hidden',
    },
  };
}

function getRandomAvatarSources(userId) {
  const allValues = [
    'AnonymousAvatarAnchor_Black',
    /* 'AnonymousAvatarAnchor_Blue', */
    'AnonymousAvatarAnchor_Pink',
    'AnonymousAvatarAnchor_Purple',
    'AnonymousAvatarAnchor_Teal',
    'AnonymousAvatarCD_Black',
    /* 'AnonymousAvatarCD_Blue', */
    'AnonymousAvatarCD_Pink',
    'AnonymousAvatarCD_Purple',
    'AnonymousAvatarCD_Teal',
    'AnonymousAvatarHeadphones_Black',
    /* 'AnonymousAvatarHeadphones_Blue', */
    'AnonymousAvatarHeadphones_Pink',
    'AnonymousAvatarHeadphones_Purple',
    'AnonymousAvatarHeadphones_Teal',
    'AnonymousAvatarMusicMic_Black',
    /* 'AnonymousAvatarMusicMic_Blue', */
    'AnonymousAvatarMusicMic_Pink',
    'AnonymousAvatarMusicMic_Purple',
    'AnonymousAvatarMusicMic_Teal',
    'AnonymousAvatarMusicNotes_Black',
    /* 'AnonymousAvatarMusicNotes_Blue', */
    'AnonymousAvatarMusicNotes_Pink',
    'AnonymousAvatarMusicNotes_Purple',
    'AnonymousAvatarMusicNotes_Teal',
    'AnonymousAvatarRadioMic_Black',
    /* 'AnonymousAvatarRadioMic_Blue', */
    'AnonymousAvatarRadioMic_Pink',
    'AnonymousAvatarRadioMic_Purple',
    'AnonymousAvatarRadioMic_Teal',
    'AnonymousAvatarRadio_Black',
    /* 'AnonymousAvatarRadio_Blue', */
    'AnonymousAvatarRadio_Pink',
    'AnonymousAvatarRadio_Purple',
    'AnonymousAvatarRadio_Teal',
    'AnonymousAvatarSatellite_Black',
    /* 'AnonymousAvatarSatellite_Blue', */
    'AnonymousAvatarSatellite_Pink',
    'AnonymousAvatarSatellite_Teal',
    'AnonymousAvatarSpeaker_Black',
    /* 'AnonymousAvatarSpeaker_Blue', */
    'AnonymousAvatarSpeaker_Pink',
    'AnonymousAvatarSpeaker_Purple',
    'AnonymousAvatarSpeaker_Teal',
    'AnonymousAvatarVolume_Black',
    /* 'AnonymousAvatarVolume_Blue', */
    'AnonymousAvatarVolume_Pink',
    'AnonymousAvatarVolume_Teal',
  ];
  const baseName = allValues[userId % allValues.length];
  if (baseName) {
    return {
      oneX: `https://d12xoj7p9moygp.cloudfront.net/images/avatars/${baseName}.imageset/${baseName}.png`,
      twoX: `https://d12xoj7p9moygp.cloudfront.net/images/avatars/${baseName}.imageset/${baseName}@2x.png`,
    };
  }
  return null;
}
